// @ts-nocheck: converted from JS

import Show from '@/components/Subjects/Show';

export default Show;
